import React from "react";
import TimeSlots from "./timeSlots/timeSlots";
import Typography from "@mui/material/Typography";
import { Box, FormControl, Grid, InputLabel } from "@mui/material";
import { useState } from "react";
import styles from "./volunteer.module.scss"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { object, string, ValidationError } from "yup";
import { useNavigate } from "react-router-dom";
import Above18 from "./above18Component";
import Below18, { CustomTextFeild } from "./below18Component";
import { toast } from "react-hot-toast";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import { isEmpty, isNil } from "lodash";
import ToastComponent from "../common/toastComponent";
import { apiRequest, catchErrorMessageHandler } from "../../infrastructure/backendService";
import { CustomSelect, CustomMenuItem, CustomRequiredInputLabel, ContactNumberInput, CommonButton } from "../common/StyledComponents/StyledFields";
import apiPath from "../../config/apiPaths.json";

interface ErrorMessageTypes {
  // loginId:string;
  firstName: string;
  lastName: string;
  age: string;
  zipcode: string;
  email: string;
  phoneNumber: string;
}

export interface below18FormProps {
  parentEmailId: string;
  parentPhoneNo: string;
}

const DosList = () => (
  <Box>
    <Typography sx={{ color: " var(--Style-1, #22A699)" }}>
      <b>Do's</b>
    </Typography>
    <ol>
      <li>
        Please arrive on time. If you cannot, kindly inform us ahead of time by
        calling 925-449-6255.
      </li>
      <li>
        Park your car at{" "}
        <span style={{ fontWeight: "bold" }}>
          {" "}
          Croce School (5650 Scenic Avenue, Livermore, CA 94551).
        </span>
      </li>
      <li>
        Check in at the volunteer registration center{" "}
        <span style={{ fontWeight: "bold" }}>
          (Palani Room) next to the Admin office
        </span>{" "}
        and pick up the badge.
      </li>
      <li>
        Familiarize yourself with the devotee movement orchestration,
        <span style={{ fontWeight: "bold" }}>
          {" "}
          including the closest exit doors, fire extinguisher, and water.
        </span>
      </li>
      <li>
        In case of health issues or injury to any devotee (non-critical),
        <span style={{ fontWeight: "bold" }}>
          {" "}
          please inform the person in your area, who will, in turn,
        </span>{" "}
        inform the Command/Control center. We have a doctor on call at all
        times. If you believe it is an emergency, please call 911 (ensure it is
        a real emergency involving serious health issues that require immediate
        medical attention).
      </li>
      <li>
        <span style={{ fontWeight: "bold" }}>
          If you are co-volunteering with children aged 14 years or younger,
          please stay with them during the entire volunteer time.
        </span>{" "}
        Any kids aged 14-18 need to volunteer under adult supervision.
      </li>
      <li>
        Inform the lead in your area when you want to take a break or if you
        face any issues.
      </li>
      <li>
        All traffic/parking volunteers should wear warm clothing and carry a
        water bottle.
      </li>
      <li>
        For volunteers helping with line orchestration, please follow the dress
        code and remain silent.
      </li>
      <li>
        After you volunteer, please check out at the volunteer registration
        center and hand over the badge.
      </li>
    </ol>
  </Box>
);
const DontsList = () => (
  <Box>
    <Typography sx={{ color: " var(--Style-1, #22A699)" }}>
      <b>Don’ts</b>
    </Typography>
    <ol>
      <li>
        If you are under 18, avoid involvement in the Kitchen or Parking areas
        or heavy lifting tasks.
      </li>
      <li>
        Please do not argue/confront any devotees. If there is any issue, inform
        the lead. Be polite and accommodating.
      </li>
      <li>
        Minimize social conversations while volunteering so that all devotees
        feel very welcome.
      </li>
      <li>
        No eating or chewing while working in food
        preparation/packing/distribution areas. Please wear gloves and hair caps
        at all times while in the Kitchen.
      </li>
      <li>
        Kindly refrain from offering personal favors to friends or acquaintances
        to bypass lines.
      </li>
    </ol>
  </Box>
);

const RegisterForm = () => {
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    // loginId:'',
    firstName: "",
    lastName: "",
    age: "",
    zipcode: "",
    email: "",
    phoneNumber: "",
  });

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const validationSchema = object().shape({
    // loginId: string().required("Login ID is required"),
    firstName: string().required("First Name is required"),
    lastName: string().required("Last Name is required"),
    age: string().required("Age is required"),
    email: string()
    .required('Email is required')
    .matches(emailRegex, 'Please enter valid email address')
    .min(6, 'Email must be at least 6 characters')
    .max(64, 'Email cannot exceed 64 characters'),
    zipcode: string()
      .required("Zipcode is required")
      .length(5, "Enter valid Zip Code"),
      phoneNumber: string()
      .required("Phone Number is required")
      .matches(/^\d{10}$/, "Phone Number should be 10 digits"),
  });

  const [formData, setFormData] = useState({
    //  loginId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    age: "18 and Above",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    email: "",
    phoneNumber: "",
    representing: "",
  });

  const navigate = useNavigate();
  const [showAbove18, setShowAbove18] = useState<boolean>(false);
  const [showBelow18, setShowBelow18] = useState<boolean>(false);
  const [showRegisterForm, setShowRegisterForm] = useState<boolean>(true);
  const [below18FormData, setBelow18FormData] = useState<below18FormProps>({
    parentEmailId: "",
    parentPhoneNo: "",
  });
  const [showParentField, setShowParentField] = useState<boolean>(false);
  const [parentName, setParentname] = useState<string>("");
  const [parentNameErr, setParentnameErr] = useState<string>("");
  const [continueDisable, setcontinueDisable] = useState<boolean>(true);

  const Ages = [
    {
      age: "18 and Above",
    },
    {
      age: "14 years to 18 Years",
    },
  ];

  const handleFieldChange = (field: string, value: any) => {
    if (field === "age") {
      if (value === "14 years to 18 Years") {
        setFormData({
          ...formData,
          [field]: value,
        });
        setShowParentField(true);
        setParentname("");
        setParentnameErr("");
      } else {
        setFormData({
          ...formData,
          [field]: value,
        });
        setShowParentField(false);
        setParentname("");
        setParentnameErr("");
      }
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const AgeDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "269px" }}>
        <CustomSelect
        className={styles.textField}
          IconComponent={KeyboardArrowDownIcon}
          defaultValue="18 and Above"
          id="grouped-select"
          value={formData.age}
          onChange={(e:any) => {
            setErrorMessage({ ...errorMessage, age: "" });
            handleFieldChange("age", e.target.value);
          }}
          MenuProps={{
            PaperProps: {
               sx: {
                  border: '1px solid #F05802',
                  '& ul': {
                     paddingTop: 0,
                     paddingBottom: 0,
                     overflowY: 'auto',
                     minHeight: 'auto',
                     maxHeight: '300px',
                     '&::-webkit-scrollbar': {
                        width: '8px',
                     },
                     '&::-webkit-scrollbar-thumb': {
                        background: '#F3C539',
                        borderRadius: '6px',
                     },
                  },
               },
            },
         }}
          //    className={errorMessage.age ? styles.errorTextFeild : ''}
        >
          {Ages.map((item, index) => (
            <CustomMenuItem key={index} value={item.age}>
              {item.age}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.age && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.age}
          </Typography>
        )}
      </FormControl>
    );
  };

  const zipCodeApiContinue = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cityAndStateApi,
      params: {
        zip: formData.zipcode,
      },
    })
      .then((res:any) => {
        setcontinueDisable(false);
        setErrorMessage({
          ...errorMessage,
          zipcode: "",
        });
        setFormData({
          ...formData,
          state: res.data.stateName,
          city: res.data.city,
        });
        saveApiCall();
      })
      .catch((err:any) => {
        setcontinueDisable(true);
        console.log(err);
        
        setErrorMessage({
          ...errorMessage,
          zipcode: catchErrorMessageHandler(err),
        });
        setFormData({
          ...formData,
          state: "",
          city: "",
        });
      });
  };

  const handleSave = async (): Promise<void> => {
    console.log(formData);

    // if(!continueDisable) {
    if (showParentField) {
      if (parentName === "") {
        setParentnameErr("Enter Parent Name");
      } else {
        const errors: ErrorMessageTypes = {
          // loginId:'',
          firstName: "",
          lastName: "",
          age: "",
          zipcode: "",
          email: "",
          phoneNumber: "",
        };

        try {
          // Validate the form data against the validation schema
          await validationSchema.validate(formData, { abortEarly: false });
          // If validation passes, you can submit the form
          setErrorMessage(errors);
          // alert('Registration Successful');
          // Call your API or perform other actions here
          // saveApiCall();
          zipCodeApiContinue();
          // console.log("Register Successful")
        } catch (error: any) {
          // Handle validation errors

          if (error instanceof ValidationError) {
            error.inner.forEach((e: any) => {
              if (e.path) {
                errors[e.path as keyof ErrorMessageTypes] = e.message;
              }
            });
          }
          setErrorMessage(errors);
        }
      }
    } else {
      const errors: ErrorMessageTypes = {
        // loginId:'',
        firstName: "",
        lastName: "",
        age: "",
        zipcode: "",
        email: "",
        phoneNumber: "",
      };

      try {
        // Validate the form data against the validation schema
        await validationSchema.validate(formData, { abortEarly: false });
        // If validation passes, you can submit the form
        setErrorMessage(errors);
        // Call your API or perform other actions here
        // saveApiCall();
        zipCodeApiContinue();
        // console.log("Register Successful")
      } catch (error: any) {
        // Handle validation errors

        if (error instanceof ValidationError) {
          error.inner.forEach((e: any) => {
            if (e.path) {
              errors[e.path as keyof ErrorMessageTypes] = e.message;
            }
          });
        }
        setErrorMessage(errors);
      }
    }
    // }
  };

  const saveApiCall = () => {
    if (formData?.age === "18 and Above") {
      //   navigate(`/above18/${formData?.age}`);
      setShowAbove18(true);
      setShowRegisterForm(false);
      setShowBelow18(false);
    } else if (formData?.age === "14 years to 18 Years") {
      //   navigate(`/below18/${formData?.age}`)
      setShowAbove18(false);
      setShowRegisterForm(false);
      setShowBelow18(true);
    } else {
      //   navigate(`/2024registerform`)
      setShowAbove18(false);
      setShowRegisterForm(true);
      setShowBelow18(false);
    }
  };

  const apiCall = () => {
    const reqBody = {
      isBelowEighteen: formData.age === "18 and Above" ? false : true,
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      address1: formData.address,
      address2: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zipcode,
      phoneNo: formData.phoneNumber,
      emailId: formData.email,
      organizationName: formData.representing,
      parentName: parentName,
      parentPhoneNo: below18FormData.parentPhoneNo,
      parentEmailId: below18FormData.parentEmailId,
    };
    console.log(reqBody);
    apiRequest({
      method: "POST",
      endpoint: apiPath.volunteerRegistration,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res: any) => {
        console.log(res);
        sessionStorage.setItem("userID", res.data.id);
        // toast.success(
        //   "Volunteer Registered successful, Please continue to select the slots."
        // );
        if (formData?.age === "18 and Above") {
          navigate(`/timeslots/${formData?.age}`);
        } else if (formData?.age === "14 years to 18 Years") {
          navigate(`/timeslots/${formData?.age}`);
        } else {
          navigate(`/`);
        }
      })
      .catch((err: any) => {
        console.log(err);
        toast.error(
          isNil(err.response.data) ? `${err.message}` : `${err.response.data}`
        );
      });
  };

  const zipCodeApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cityAndStateApi,
      params: {
        zip: formData.zipcode,
      },
    })
      .then((res) => {
        setcontinueDisable(false);
        setErrorMessage({
          ...errorMessage,
          zipcode: "",
        });
        console.log(res.data.stateName);
        setFormData({
          ...formData,
          state: res.data.stateName,
          city: res.data.city,
        });
      })
      .catch((err) => {
        setcontinueDisable(true);
        console.log(err);
        
        setErrorMessage({
          ...errorMessage,
          zipcode: catchErrorMessageHandler(err),
        });
        setFormData({
          ...formData,
          state: "",
          city: "",
        });
      });
  };

  const validateEmail = () => {
    const { email } = formData;

    if (email.length < 6) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be at least 6 characters long.",
      });
    } else if (email.length >= 64) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be less than 64 characters long.",
      });
    } else if (!email.includes("@")) {
      setErrorMessage({
        ...errorMessage,
        email: "Please Enter Valid Email",
      });
    } else {
      setErrorMessage({ ...errorMessage, email: "" });
    }
  };

  const validateAlphabetsAndSpaces = (value: string) => {
    const regex = /^[a-zA-Z\s]*$/;
    return regex.test(value);
  };

  const defalutForm = (): JSX.Element => {
    return (
      <Box className={styles.totalConatiner}>
        {/* <Typography className={styles.heading}>
          New Year 2024 Volunteer Registration Form – Day, Timeslot, and
          Category
        </Typography> */}
        <Box className={styles.formConatiner}>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={3}>
              {CustomRequiredInputLabel("Age", true)}
              {AgeDropdown()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid xs={12} sm={3} item>
              {CustomRequiredInputLabel("First Name", true)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.firstName}
                onChange={(e:any) => {
                  const inputValue = e.target.value;
                  setErrorMessage({ ...errorMessage, firstName: "" });
                  if (validateAlphabetsAndSpaces(inputValue)) {
                    handleFieldChange("firstName", inputValue);
                  }
                }}
                className={errorMessage.firstName ? styles.errorTextField : styles.textField}
                placeholder="Enter Firstname"
              />
              {errorMessage.firstName && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.firstName}
                </Typography>
              )}
            </Grid>
            <Grid xs={12} sm={3} item>
              {CustomRequiredInputLabel("Middle Name", false)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.middleName}
                onChange={(e:any) => {
                  const inputValue = e.target.value;
                  if (validateAlphabetsAndSpaces(inputValue)) {
                    handleFieldChange("middleName", inputValue);
                  }
                }}
                placeholder="Enter Middlename"
              />
            </Grid>
            <Grid xs={12} sm={3} item>
              {CustomRequiredInputLabel("Last Name", true)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.lastName}
                onChange={(e:any) => {
                  const inputValue = e.target.value;
                  setErrorMessage({ ...errorMessage, lastName: "" });
                  if (validateAlphabetsAndSpaces(inputValue)) {
                    handleFieldChange("lastName", inputValue);
                  }
                }}
                className={errorMessage.lastName ? styles.errorTextField : styles.textField}
                placeholder="Enter Lastname"
              />
              {errorMessage.lastName && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.lastName}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={3}>
              {CustomRequiredInputLabel("Email", true)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.email}
                onChange={(e:any) => {
                  setErrorMessage({ ...errorMessage, email: "" });
                  handleFieldChange("email", e.target.value);
                }}
                onBlur={validateEmail}
                className={errorMessage.email ? styles.errorTextField : styles.textField}
                placeholder="Enter Email"
              />
              {errorMessage.email ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.email}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={12} sm={3}>
              {CustomRequiredInputLabel("Contact No", true)}
              <CustomTextFeild
                required
                fullWidth
                value={formData.phoneNumber}
                onChange={(e:any) => {
                  setErrorMessage({ ...errorMessage, phoneNumber: "" });
                  const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                  const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                  handleFieldChange("phoneNumber", slicedNumber);
                }}
                className={errorMessage.phoneNumber ? styles.errorTextField : styles.textField}
                placeholder="Enter Phone Number"
              />
              {errorMessage.phoneNumber ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.phoneNumber}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={12} sm={3}>
              {CustomRequiredInputLabel("Address", false)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.address}
                onChange={(e:any) => {
                  handleFieldChange("address", e.target.value);
                }}
                placeholder="Enter Address"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={3}>
              {CustomRequiredInputLabel("City", false)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.city}
                onChange={(e:any) => {
                  handleFieldChange("city", e.target.value);
                }}
                // InputProps={{
                //   readOnly: true,
                // }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              {CustomRequiredInputLabel("State", false)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.state}
                onChange={(e:any) => {
                  handleFieldChange("state", e.target.value);
                }}
                // InputProps={{
                //   readOnly: true,
                // }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              {CustomRequiredInputLabel("Zip Code", true)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.zipcode}
                onChange={(e:any) => {
                  const inputValue = e.target.value;
                  // Only allow numbers
                  const sanitizedInput = inputValue.replace(/[^0-9]/g, "");
                  setErrorMessage({ ...errorMessage, zipcode: "" });
                  handleFieldChange("zipcode", sanitizedInput);
                }}
                onBlur={zipCodeApi}
                placeholder="Enter Zipcode"
                className={errorMessage.zipcode ? styles.errorTextField : styles.textField}
              />
              {errorMessage.zipcode ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.zipcode}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={3}>
              <div style={{ display: "flex" }}>
                {CustomRequiredInputLabel("Representing Organization", false)}
                <Tooltip
                  title="Self/Family/Organization/Group Volunteering"
                  placement="top"
                  arrow
                >
                  <InfoOutlinedIcon
                    sx={{ marginLeft: "10px", fontSize: "20px" }}
                  />
                </Tooltip>
              </div>
              <CustomTextFeild
                fullWidth
                required
                value={formData.representing}
                onChange={(e:any) => {
                  handleFieldChange("representing", e.target.value);
                }}
                placeholder="Enter Lastname"
              />
            </Grid>
            {showParentField ? (
              <Grid item xs={12} sm={3}>
                {CustomRequiredInputLabel("Parent Name", true)}
                <CustomTextFeild
                  fullWidth
                  required
                  value={parentName}
                  onChange={(e:any) => {
                    setParentnameErr("");
                    const inputValue = e.target.value;
                    if (validateAlphabetsAndSpaces(inputValue)) {
                      setParentname(inputValue);
                    }
                  }}
                  placeholder="Enter Parent Name"
                />
                {parentNameErr && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {parentNameErr}
                  </Typography>
                )}
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          
        </Box>

        <Box>
          <Typography className={styles.DosDonts}>
            Volunteer Do’s and Don'ts. Be Committed.
          </Typography>
          {DosList()}
          {DontsList()}
          <CommonButton
            disabled={continueDisable}
            sx={{ marginTop: "24px" }}
            onClick={handleSave}
          >
            Continue
          </CommonButton>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <ToastComponent />
      {showRegisterForm ? defalutForm() : ""}
      {showAbove18 ? (
        <Above18
          callApi={apiCall}
          ParticipantName={`${formData.firstName} ${formData.middleName} ${formData.lastName}`}
          setShowRegisterForm={setShowRegisterForm}
          setShowAbove18={setShowAbove18}
        />
      ) : (
        ""
      )}
      {showBelow18 ? (
        <Below18
          below18FormData={below18FormData}
          setBelow18FormData={setBelow18FormData}
          callApi={apiCall}
          parentName={parentName}
          ParticipantName={`${formData.firstName} ${formData.middleName} ${formData.lastName}`}
          setShowBelow18={setShowBelow18}
          setShowRegisterForm={setShowRegisterForm}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default RegisterForm;
